import PropTypes from 'prop-types';
import React from 'react';
import classnames from 'classnames';
import _ from 'underscore';
import ModalActionCreator from 'action_creators/modal';
import MessageGuide from 'views/plugins/confirmation/message_guide';
import Body from 'views/plugins/confirmation/body';
import Cover from 'views/plugins/checkout/mobile/screens/cover';
import { FormattedMessage, injectIntl } from 'react-intl';

import styled from '@emotion/styled';
import { Theme } from 'ui_system/theme';

const ThankYou = styled.h2`
  padding-top: 32px;
  margin-top: 0;
  font-size: 26px;
  margin-bottom: 16px;
  font-weight: 500;
`;

const SendMessage = styled.a`
  color: ${Theme.colors.linksDesignElementsBaseColor};
`;

const TourName = styled.h3`
  color: ${Theme.colors.previewSecondaryTextColor};
  margin-top: 8px;
`;

const AllSetText = styled.p``;

class ConfirmationMobileMessage extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      email: this.props.tourist_email,
      displayError: false,
    };
  }

  static displayName = 'ConfirmationMobile-MessageScreen-Plugins';

  static propTypes = {
    tour_picture: PropTypes.string.isRequired,
  };

  setEmail = (value) => {
    let displayError;
    //check if email is valid
    if (/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value)) {
      displayError = false;
    } else {
      displayError = true;
    }
    //Update the value in the input box regardless of validity
    this.setState({
      displayError,
      email: value,
    });
  };

  _showMessageGuideModal = (e) => {
    e.preventDefault();
    ModalActionCreator.show({
      content: (
        <MessageGuide {...this._messageGuideProps()} email={this.state.email} />
      ),
      triggeringElement: e.currentTarget,
      className: 'Confirmation-Message-Guide-Modal small',
    });
  };

  _messageGuideProps = () => {
    return {
      guide_full_name: this.props.guide_full_name,
      recipient_id: this.props.recipient_id,
      sender_id: this.props.sender_id,
      booking_id: this.props.booking_id,
    };
  };

  _messageGuideFooterContent = () => {
    const { affiliate_portal_link } = this.props;
    if (affiliate_portal_link) return null;

    const style = { color: this.props.link_color };

    return (
      <p>
        <FormattedMessage
          defaultMessage="Have questions for us?{br}<link>Send a message</link>"
          description="Prompt asking if guest has questions with link to send message"
          values={{
            br: <br />,
            link: (chunks) => (
              <SendMessage
                href=""
                onClick={this._showMessageGuideModal}
                style={style}
              >
                {chunks}
              </SendMessage>
            ),
          }}
        />
      </p>
    );
  };

  _viewProps = () => {
    const {
      show_details,
      paid_in_cash,
      custom_title,
      custom_body,
      link_color,
      ticketed_event,
    } = this.props;

    return {
      ...this.props,
      footer_content: this._messageGuideFooterContent(),
      show_details,
      paid_in_cash,
      custom_title,
      custom_body,
      link_color,
      ticketed_event,
    };
  };

  _coverProps = () => {
    return {
      forInvoice: this.props.for_invoice,
      guestPaidInvoice: this.props.guest_paid_invoice,
      tourPicture: this.props.tour_picture,
      guideAvatar: this.props.guide_avatar,
      tourName: this.props.tour_name,
      guideName: this.props.guide_full_name,
      hasResource: this.props.has_resource,
      resourceName: this.props.resource_name,
      isLiveBooking: this.props.is_live_booking,
      linkColor: this.props.link_color,
      brandColor: this.props.brand_color,
      businessName: this.props.business_name,
      liveBrandingColor: this.props.live_branding_color,
    };
  };

  _renderLiveBody = () => {
    const { is_live_booking, tour_name, guide_full_name, first_name } =
      this.props;
    return (
      <div>
        <TourName>{tour_name}</TourName>
        <ThankYou>
          {this.props.headline ||
            this.props.intl.formatMessage(
              {
                defaultMessage: 'Thank you, {name}!',
                description: 'Thank you message with guest first name',
              },
              { name: first_name }
            )}
        </ThankYou>
        <AllSetText>
          {this.props.sub_headline ? (
            <div
              dangerouslySetInnerHTML={{ __html: this.props.sub_headline }}
            />
          ) : (
            <FormattedMessage
              defaultMessage="You''re all set."
              description="Confirmation that booking is complete"
            />
          )}
        </AllSetText>
      </div>
    );
  };

  render() {
    const { is_live_booking } = this.props;
    const confirmationCssClasses = classnames(
      'ConfirmationMobile-PageContent',
      {
        'is-live': is_live_booking,
      }
    );

    return (
      <div
        className={`ConfirmationMobile-Screen ConfirmationMobile-Message ${
          is_live_booking && 'liveBooking-Container'
        }`}
      >
        {!is_live_booking && (
          <div className="ConfirmationMobile-ScreenHeader transition-ctx">
            <FormattedMessage
              defaultMessage="Thank you"
              description="Thank you page header"
            />
            !
          </div>
        )}
        <div className="ConfirmationMobile-ScreenContent transition-ctx">
          <Cover {...this._coverProps()} />
          <div className={confirmationCssClasses}>
            {is_live_booking ? (
              this._renderLiveBody()
            ) : (
              <Body
                {...this._viewProps()}
                displayError={this.state.displayError}
                email={this.state.email}
                setEmail={this.setEmail}
              />
            )}
          </div>
        </div>
      </div>
    );
  }
}

export default injectIntl(ConfirmationMobileMessage);
